import {
  campaignCreationParametersSchema,
  populatedCampaignSchema,
} from "@redotech/redo-model/campaigns/campaign-definition";

export const createCampaign = {
  input: campaignCreationParametersSchema,
  output: populatedCampaignSchema,
};
